import React, {Component} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import propTypes from 'prop-types'
import {trackEvent} from 'helpers/tracking'

export const LINK_TYPE = {
  LINK: 'LINK',
  NEW_TAB: 'NEW_TAB',
  DOWNLOAD: 'DOWNLOAD',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
}

class ActionLink extends Component {

  openOnNewTab = () => {
    const {href} = this.props
    const a = document.createElement('a')
    a.href = href
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.click()
  }

  downloadLoadFile = () => {
    const {href, title} = this.props
    const a = document.createElement('a')
    a.href = href
    a.download = title
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.click()
  }

  openProtocolLink = () => {
    const {href} = this.props
    const a = document.createElement('a')
    a.href = href
    a.click()
  }

  onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {href, category, action, label, type, onChangeRoute} = this.props
    trackEvent(category, action, label)

    switch (type) {
      case LINK_TYPE.NEW_TAB:
        this.openOnNewTab()
        break
      case LINK_TYPE.DOWNLOAD:
        this.downloadLoadFile()
        break
      case LINK_TYPE.EMAIL:
        this.openProtocolLink()
        break
      case LINK_TYPE.PHONE:
        this.openProtocolLink()
        break
      default:
        onChangeRoute(href)
        break
    }
  }

  render() {
    const {href, className, label, title} = this.props
    return (
        <a href={href} className={className} title={label} onClick={this.onClick}>
          {title ? title : label}
        </a>
    )
  }
}

ActionLink.propTypes = {
  href: propTypes.string.isRequired,
  className: propTypes.string,
  label: propTypes.string.isRequired,
  title: propTypes.string,
  category: propTypes.string,
  action: propTypes.string,
  type: propTypes.string,
  onChangeRoute: propTypes.func.isRequired,
}

ActionLink.defaultProps = {
  type: LINK_TYPE.LINK,
}


const mapDispatchToProps = (dispatch) => {
  return {
    onChangeRoute: (url) => dispatch(push(url)),
  }
}

export default connect(null, mapDispatchToProps)(ActionLink)

